import { CreateRole, UpdateRole } from '@/types';
import { AxiosResponse } from 'axios';
import { QueryFunctionContext } from '@tanstack/react-query';
import APIService from './base.service';
import { IRole } from '@/interfaces';

export class RoleService {

  static getRolesWithLimitLevel({
    queryKey: [_, level],
  }: QueryFunctionContext<string[]>): Promise<AxiosResponse<IRole[]>> {
    return APIService.get('/roles', { params: { level } });
  }

  static getRolesByTenant(tenantId: string): Promise<AxiosResponse<IRole[]>> {
    return APIService.get('/roles', { params: { tenantId } });
  }

  static createRole(payload: CreateRole): Promise<AxiosResponse> {
    return APIService.post('roles', payload);
  }

  static updateRole(payload: UpdateRole): Promise<AxiosResponse> {
    const { id, addedScopes, removedScopes, level, name } = payload;
    return APIService.put('roles/' + id, {
      addedScopes,
      removedScopes,
      level,
      name,
    });
  }
}
